<template>
  <div class="error-alert">
    <span class="span-placeholder">
      <i class="fal fa-exclamation-triangle" />
    </span>
    <p>
      <slot></slot>
    </p>
  </div>
</template>

<script>
// @ts-check
export default {
  name: 'WarningAlert'
}
</script>

<style lang="scss" scoped>
.error-alert {
  padding: 1rem;
  background-color: #FFF4E5;
  border: 1px solid #DDC5A4;
  border-radius: 15px;
  font-weight: 600;
  font-size: 14px;
  color: #663C00;
  margin-top: 10px;
  display: grid;
  grid-template-columns: 15% 1fr;
  align-items: center;

  span {
    position: relative !important;
    top: auto !important;
    color: #FFA12E !important;
    left: auto !important;
    text-align: center;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/TeachersForm/components/WarningAlert.vue